import { useEffect, useState } from "react";
import axios from "axios";
import { JARS } from "@/data/catalog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const field = "w-full bg-transparent border border-[#E8DDC7]/25 rounded-sm px-3 py-2 text-[14px] text-[#E8DDC7] focus:outline-none focus:border-[#D2C08E]";

export const KeeperSettings = ({ token }) => {
  const auth = { headers: { Authorization: `Bearer ${token}` } };
  const [s, setS] = useState(null);
  const [msg, setMsg] = useState("");
  useEffect(() => { axios.get(`${API}/site-settings`).then((r) => setS(r.data)).catch(() => setS({ ordering_open: false, sourcing_where: {} })); }, []);
  const save = async (patch) => {
    const { data } = await axios.post(`${API}/keeper/site-settings`, patch, auth);
    setS(data);
    setMsg("Saved. Shoppers see it on their next page load.");
  };
  if (!s) return <p className="mt-6 text-[#E8DDC7]/70">Opening…</p>;
  return (
    <div className="mt-8 space-y-10 max-w-2xl" data-testid="keeper-settings">
      <section>
        <h2 className="font-display text-2xl text-[#E8DDC7]">Ordering</h2>
        <p className="mt-1 text-[14px] text-[#E8DDC7]/80">
          {s.ordering_open ? "Ordering is OPEN: buttons say Add to cart and checkout takes real payments." : "Ordering is closed: buttons say Notify me and collect sign-ups. Checkout is blocked."}
        </p>
        <button data-testid="keeper-ordering-toggle" onClick={() => save({ ordering_open: !s.ordering_open })} className={s.ordering_open ? "btn-outline mt-4" : "btn-primary mt-4"}>
          {s.ordering_open ? "Close ordering" : "Open ordering"}
        </button>
      </section>
      <section>
        <h2 className="font-display text-2xl text-[#E8DDC7]">Sourcing: “Where” column on Our Standard</h2>
        <p className="mt-1 text-[14px] text-[#E8DDC7]/80">Leave blank to show a dash. Only write what is true for every batch.</p>
        <div className="mt-4 space-y-3">
          {JARS.map((p) => (
            <label key={p.id} className="block">
              <span className="text-[13px] text-[#E8DDC7]/85">{p.name}</span>
              <input data-testid={`keeper-where-${p.id}`} className={field} maxLength={80} value={s.sourcing_where?.[p.id] || ""}
                onChange={(e) => setS({ ...s, sourcing_where: { ...s.sourcing_where, [p.id]: e.target.value } })} />
            </label>
          ))}
        </div>
        <button data-testid="keeper-where-save" onClick={() => save({ sourcing_where: s.sourcing_where })} className="btn-outline mt-4">Save sourcing</button>
      </section>
      {msg && <p className="text-[13px] text-[#D2C08E]" data-testid="keeper-settings-msg">{msg}</p>}
    </div>
  );
};

export const KeeperFaq = ({ token }) => {
  const auth = { headers: { Authorization: `Bearer ${token}` } };
  const [d, setD] = useState(null);
  const load = () => axios.get(`${API}/keeper/faq-draft`, auth).then((r) => setD(r.data)).catch(() => setD({ items: [] }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, []);
  const act = async (action) => { await axios.post(`${API}/keeper/faq-draft/${action}`, {}, auth); load(); };
  const items = Array.isArray(d?.items) ? d.items : [];
  if (!d) return <p className="mt-6 text-[#E8DDC7]/70">Opening…</p>;
  return (
    <div className="mt-8 max-w-3xl" data-testid="keeper-faq">
      <p className="text-[14px] text-[#E8DDC7]/85">Each week a new FAQ draft is written from shopper questions. Nothing changes on the Help page until you approve it.</p>
      {!items.length && <p className="mt-4 font-display text-xl text-[#E8DDC7]/85" data-testid="keeper-faq-empty">No draft waiting.</p>}
      {items.length > 0 && (
        <>
          <ol className="mt-5 space-y-4 list-decimal pl-5">
            {items.map((i) => <li key={i.en.q} className="text-[14px] text-[#E8DDC7]"><p className="font-semibold">{i.en.q}</p><p className="text-[#E8DDC7]/85">{i.en.a}</p></li>)}
          </ol>
          <div className="mt-6 flex gap-3">
            <button data-testid="keeper-faq-approve" onClick={() => act("approve")} className="btn-primary">Approve and publish</button>
            <button data-testid="keeper-faq-discard" onClick={() => act("discard")} className="btn-outline">Discard draft</button>
          </div>
        </>
      )}
    </div>
  );
};
